<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint"  />


    <!-- 파일 업로드 -->
    <div class="my-28px">
      <h5 class="my-4"><i class="dot"></i> 엑셀파일 업로드</h5>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>파일 업로드</div>
          <div>
            <vs-button color="secondary" type="border" :href="excelLink">엑셀 템플릿 다운로드</vs-button>
            <vs-button color="secondary" class="ml-2" @click="onClickExcelUpload"> 작성 엑셀 업로드 </vs-button>
            <input v-show="false" ref="excelInput" type="file" multiple @change="readFile" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
          </div>
        </div>
      </div>
    </div>

    <div class="my-28px">
      <h5 class="my-4"><i class="dot"></i> 피평가자 정보</h5>
      <div class="writeGridContainer">
        <div class="grid-column-content" vs-align="center">
          <div class="title">직위</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_1" />
        </div>
        <div class="grid-column-content" vs-align="center">
          <div class="title">성명</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_2" />
        </div>
        <div class="grid-column-content" vs-align="center">
          <div class="title">평가일</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_3 }}</p>
          <date-selector v-else class="w-full flex-1" v-model="form.inputA_3" :readonly="board.readonly"/>
        </div>
        <div class="grid-column-content" vs-align="center">
          <div class="title">반기별 구분</div>
          <div v-if="isPrint" class="flex">
            <span class="print-radio"><i><feather-icon v-if="form.inputA_4 === '상반기' " svgClasses="w-4 w-5" icon="CheckIcon" /></i>상반기</span>
            <span class="print-radio mx-4"><i><feather-icon v-if="form.inputA_4 === '하반기' " svgClasses="w-4 w-5" icon="CheckIcon" /></i>하반기</span>
          </div>
          <div v-else>
            <vs-radio v-model="form.inputA_4" vs-name="반기" vs-value="상반기" :readonly="board.readonly">상반기</vs-radio>
            <vs-radio class="mx-4" v-model="form.inputA_4" vs-name="반기" vs-value="하반기" :readonly="board.readonly">하반기</vs-radio>
          </div>
        </div>
      </div>
    </div>

    <div class="my-28px">
      <h5 class="my-4"><i class="dot"></i> 평가자 정보</h5>
      <div class="writeGridContainer">
        <div class="grid-column-content" vs-align="center">
          <div class="title">소속</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_1" />
        </div>
        <div class="grid-column-content" vs-align="center">
          <div class="title">직위</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_2" />
        </div>
        <div class="grid-column-content" vs-align="center">
          <div class="title">성명</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_3 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_3" />
        </div>
      </div>
    </div>

    <!-- 평가표 -->
    <table-inspect-merge
      :is-print="isPrint"
      :is-readonly="board.readonly"
      title="평가표"
      :table-header-title="[{ text: '평가항목' }, { text: '평가 세부 결과(개조식으로 작성)' }]"
      :table-header-check="[{ text: '양호' }, { text: '미흡' }, ]"
      :tableHeaderNote="[]"
      v-model="form.inspectList"
      class="mt-5"
    >
    </table-inspect-merge>

    <!--    사진대지-->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import DateSelector from "@/components/selector/DateSelector";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import CompanySelector from "@/components/selector/CompanySelector";

import * as inspectData from "./inspectData";
import SignField from "@/components/SignField.vue";
import TableCustom from "@/components/TableCustom.vue";
import FileUploader from "@/components/FileUploader.vue";
import Print from "@/views/boards/single-page/670/Print.vue";
import config from "../../../../../public/config";
import XLSX from "xlsx";

export default {
  components: {
    Print,
    FileUploader,
    TableCustom,
    SignField,
    FieldSelectModule,
    FileUploadModule,
    TableInspectMerge,
    DateSelector,
    DisasterClassSelector,
    CompanySelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",

        inspectList: inspectData.inspectTable,

        photoList: [],
        fileList: [],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
    excelLink() {
      return `${config.BASE_API_URL}/storage/app/media/%EC%95%88%EC%A0%84%EB%B3%B4%EA%B1%B4%EA%B4%80%EB%A6%AC%EC%B1%85%EC%9E%84%EC%9E%90_%EC%97%85%EB%AC%B4%EC%88%98%ED%96%89%ED%8F%89%EA%B0%80%ED%91%9C_%EC%97%91%EC%85%80%EC%97%85%EB%A1%9C%EB%93%9C.xlsx`;
    },
  },
  methods: {
    fieldsByType(type) {
      switch (type) {
        case 1:
        case 3:
          return [
            { label: '실시일', inputKey: 'input1', inputComponent: 'date-selector', style: { minWidth: '200px' } },
            { label: '실시일', inputKey: 'input2', inputComponent: 'date-selector', style: { minWidth: '200px' } },
            ...(type === 3 ? [{ label: '개선사항', inputKey: 'input3', inputComponent: 'ml-input' }] : []),
            // Add more fields as needed
          ];
        case 2:
          return [
            { label: '교육대상', inputKey: 'input1', inputComponent: 'ml-input' },
            { label: '실시인원', inputKey: 'input2', inputComponent: 'ml-input' },
            // Add more fields as needed
          ];
        case 6:
          return [
            { label: '미실시 인원', inputKey: 'input1', inputComponent: 'ml-input' },
            { label: '실시인원', inputKey: 'input2', inputComponent: 'ml-input' },
            // Add more fields as needed
          ];
        case 7:
          return [
            { label: '실시일', inputKey: 'input1', inputComponent: 'date-selector', style: { minWidth: '200px' } },
            { label: '개선사항', inputKey: 'input2', inputComponent: 'ml-input' },
            { label: '조치사항', inputKey: 'input3', inputComponent: 'ml-input' },
            // Add more fields as needed
          ];
        default:
          return [];
      }
    },
    onClickExcelUpload() {
      const excelInput = this.$refs.excelInput;
      excelInput.value = null;
      excelInput.click();
    },

    // 엑셀데이터 파싱
    async readFile(event) {
      // get File object from input tag
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];
        // declare FileReader, temp result
        const reader = new FileReader();

        // if you use "this", don't use "function(e) {...}"
        reader.onload = async (e) => {
          let data = e.target.result;
          data = new Uint8Array(data);
          // get excel file
          const excelFile = XLSX.read(data, { type: "array", cellDates: true });
          const sheetData = excelFile.Sheets[excelFile.SheetNames[0]];

          // 서식
          let 직위 = this.getCellData(sheetData, "E3")
          let 성명 = this.getCellData(sheetData, "G3")

          let 평가일자 = this.getCellData(sheetData, "B4", "w")
          평가일자 = this.formatDate(평가일자)
          let 평가자소속 = this.getCellData(sheetData, "D5")
          let 평가자직위 = this.getCellData(sheetData, "F5")
          let 평가자성명 = this.getCellData(sheetData, "H5")

          // table data
          let tableData = [];
          for (let i = 11; i < 22; i++) {
            let 평가결과 = "";
            if (this.getCellData(sheetData, `I${i}`)) {
              평가결과 = "양호";
            } else if (this.getCellData(sheetData, `J${i}`)) {
              평가결과 = "미흡";
            }
            const row = {
              content: [
                { value: this.getCellData(sheetData, `E${i}`) },
              ],
              isChecked: 평가결과,
            };
            tableData.push(row);
          }

          // 결과
          this.form.inputA_1 = 직위;
          this.form.inputA_2 = 성명;
          this.form.inputA_3 = 평가일자;

          this.form.inputB_1 = 평가자소속;
          this.form.inputB_2 = 평가자직위;
          this.form.inputB_3 = 평가자성명;

          for(let i = 0; i < this.form.inspectList.length; i++) {
            this.form.inspectList[i].content[1].value = tableData[i].content[0].value;
            this.form.inspectList[i].isChecked = tableData[i].isChecked;
          }
        };
        reader.readAsArrayBuffer(file);
      }
    },

    getCellData(sheet, cell, key = "v") {
      // sheet[row]가 존재하고, 해당 cell 존재하는지 확인
      // sheet[cell].v : Raw value
      // sheet[cell].w : Formatted value
      // sheet[cell].t : Type
      if (sheet[cell] !== undefined) {
        return sheet[cell][key];
      } else {
        return "";
      }
    },
    formatDate(date) {
      const d = new Date(date),
        year = d.getFullYear(),
        month = ('0' + (d.getMonth() + 1)).slice(-2),
        day = ('0' + d.getDate()).slice(-2);

      return [year, month, day].join('-');
    },
  },
};
</script>

<style scoped lang="scss">
.print-radio,
.print-checkbox {
  display: flex;
  align-items: center;

  & > i {
    width: 20px;
    height: 20px;
    border: 2px solid #cdcdcd;
    position: relative;
    margin-right: 6px;
  }
  & .feather-icon {
    transform: translateY(-4px);
  }
}

.print-radio {
  & > i {
    border-radius: 20px;
  }
}
</style>
